var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.error)?_c('TixMessage',{attrs:{"type":"error","plain":_vm.error}}):_c('Loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }